'use client';

import { Button } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

export const ResetButton = ({ children, ...buttonProps }: ButtonProps) => {
	const { formState: { isDirty, isSubmitting } } = useFormContext();
	const isDisabled = !isDirty || isSubmitting;

	return (
		<Button
			disabled={isDisabled}
			loading={isSubmitting}
			{...buttonProps}
			type="reset"
		>
			{children}
		</Button>
	);
};
